module.exports = __webpack_public_path__ + "media/images/icon-dots2-4927721005b8732a79fc3e8e0503bc9b.svg";